var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 351,
    viewBox: "0 0 750 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_595",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 751,
    height: 351
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M749 0.5V350.5H0V0.5H749Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.613 371.9C138.109 236.46 282.682 158.976 419.004 183.572C470.971 192.948 521.762 215.749 574.19 214.279C635.173 212.569 694.17 175.605 728.308 117.72C762.446 59.8338 770.886 -17.5492 750.355 -84.4302",
    stroke: "url(#paint0_linear_12_595)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.136 381.314C138.632 245.874 283.205 168.39 419.527 192.986C471.494 202.362 522.285 225.163 574.713 223.693C635.696 221.983 694.693 185.019 728.831 127.134C762.969 69.2479 771.409 -8.13512 750.878 -75.0161",
    stroke: "url(#paint1_linear_12_595)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.658 390.727C139.154 255.287 283.727 177.803 420.049 202.399C472.016 211.775 522.807 234.576 575.235 233.106C636.218 231.396 695.215 194.432 729.353 136.547C763.491 78.661 771.931 1.27797 751.4 -65.603",
    stroke: "url(#paint2_linear_12_595)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1809 400.142C139.677 264.702 284.25 187.218 420.572 211.814C472.539 221.19 523.33 243.991 575.758 242.521C636.741 240.811 695.738 203.847 729.876 145.962C764.014 88.076 772.454 10.693 751.923 -56.188",
    stroke: "url(#paint3_linear_12_595)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7039 409.555C140.2 274.115 284.773 196.631 421.095 221.227C473.062 230.603 523.853 253.404 576.281 251.934C637.264 250.224 696.261 213.26 730.399 155.375C764.537 97.4886 772.977 20.1056 752.446 -46.7754",
    stroke: "url(#paint4_linear_12_595)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.226 418.97C140.722 283.53 285.295 206.046 421.617 230.642C473.584 240.018 524.375 262.819 576.803 261.349C637.786 259.639 696.783 222.675 730.921 164.79C765.059 106.904 773.499 29.5206 752.968 -37.3604",
    stroke: "url(#paint5_linear_12_595)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7489 428.382C141.245 292.942 285.818 215.458 422.14 240.054C474.107 249.43 524.898 272.231 577.326 270.761C638.309 269.051 697.306 232.087 731.444 174.202C765.582 116.316 774.022 38.9328 753.491 -27.9482",
    stroke: "url(#paint6_linear_12_595)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2709 437.796C141.767 302.356 286.34 224.872 422.663 249.468C474.63 258.844 525.421 281.645 577.849 280.175C638.832 278.465 697.829 241.501 731.967 183.616C766.105 125.73 774.545 48.3468 754.014 -18.5342",
    stroke: "url(#paint7_linear_12_595)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7939 447.21C142.29 311.77 286.863 234.286 423.185 258.882C475.152 268.258 525.943 291.059 578.371 289.589C639.354 287.879 698.351 250.915 732.489 193.03C766.627 135.144 775.067 57.7609 754.536 -9.12012",
    stroke: "url(#paint8_linear_12_595)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3169 456.624C142.813 321.184 287.386 243.7 423.708 268.296C475.675 277.672 526.466 300.473 578.894 299.003C639.877 297.293 698.874 260.329 733.012 202.444C767.15 144.558 775.59 67.1749 755.059 0.293945",
    stroke: "url(#paint9_linear_12_595)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8389 466.038C143.335 330.598 287.908 253.114 424.23 277.71C476.197 287.086 526.988 309.887 579.416 308.417C640.399 306.707 699.396 269.743 733.534 211.858C767.672 153.972 776.112 76.589 755.581 9.70801",
    stroke: "url(#paint10_linear_12_595)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3619 475.452C143.858 340.012 288.431 262.528 424.753 287.124C476.72 296.5 527.511 319.301 579.939 317.831C640.922 316.121 699.919 279.157 734.057 221.272C768.195 163.386 776.635 86.0026 756.104 19.1216",
    stroke: "url(#paint11_linear_12_595)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_595",
    x1: 414.515,
    y1: -84.4302,
    x2: 414.515,
    y2: 371.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#78E1FB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_595",
    x1: 415.038,
    y1: -75.0161,
    x2: 415.038,
    y2: 381.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#78E1FB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_595",
    x1: 415.56,
    y1: -65.603,
    x2: 415.56,
    y2: 390.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#78E1FB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_595",
    x1: 416.083,
    y1: -56.188,
    x2: 416.083,
    y2: 400.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#78E1FB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_595",
    x1: 416.606,
    y1: -46.7754,
    x2: 416.606,
    y2: 409.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#78E1FB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12_595",
    x1: 417.128,
    y1: -37.3604,
    x2: 417.128,
    y2: 418.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#78E1FB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12_595",
    x1: 417.651,
    y1: -27.9482,
    x2: 417.651,
    y2: 428.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#78E1FB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12_595",
    x1: 418.174,
    y1: -18.5342,
    x2: 418.174,
    y2: 437.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#78E1FB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12_595",
    x1: 418.696,
    y1: -9.12012,
    x2: 418.696,
    y2: 447.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#78E1FB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12_595",
    x1: 419.219,
    y1: 0.293945,
    x2: 419.219,
    y2: 456.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#78E1FB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12_595",
    x1: 419.741,
    y1: 9.70801,
    x2: 419.741,
    y2: 466.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#78E1FB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12_595",
    x1: 420.264,
    y1: 19.1216,
    x2: 420.264,
    y2: 475.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#78E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#78E1FB",
    stopOpacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.91d7fbfdd6abf95c09c01a75442857e7.svg";
export { ForwardRef as ReactComponent };